import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
  Layout,
  Menu,
  Button,
  Input,
  Avatar,
  Dropdown,
  Space,
  Drawer,
  message
} from 'antd';
import {
  MenuOutlined,
  UserOutlined,
  SearchOutlined,
  HomeOutlined,
  BookOutlined,
  FormOutlined,
  LoginOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import './index.css';

const { Header: AntHeader } = Layout;
const { Search } = Input;

const AppHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerVisible, setDrawerVisible] = useState(false);
  
  // 根据当前路径设置选中的菜单项
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path.startsWith('/archive')) return 'archive';
    if (path.startsWith('/write') || path.startsWith('/edit')) return 'write';
    if (path.startsWith('/about')) return 'about';
    return '';
  };

  const [selectedKeys, setSelectedKeys] = useState([getSelectedKey()]);
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  const menuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: '首页',
      path: '/'
    },
    {
      key: 'archive',
      icon: <BookOutlined />,
      label: '归档',
      path: '/archive'
    },
    {
      key: 'write',
      icon: <FormOutlined />,
      label: '写文章',
      path: '/write'
    },
    {
      key: 'about',
      icon: <UserOutlined />,
      label: '我的',
      path: '/about'
    }
  ];

  const userMenuItems = [
    {
      key: 'profile',
      label: '个人中心',
      onClick: () => navigate('/about')
    },
    {
      key: 'settings',
      label: '设置',
      onClick: () => message.info('设置功能开发中')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
      onClick: () => {
        localStorage.removeItem('isLoggedIn');
        message.success('已退出登录');
        navigate('/');
        window.location.reload();
      }
    }
  ];

  const handleMenuClick = (e) => {
    setSelectedKeys([e.key]);
    const item = menuItems.find(item => item.key === e.key);
    if (item) {
      navigate(item.path);
      setDrawerVisible(false);
    }
  };

  const onSearch = (value) => {
    if (value.trim()) {
      message.info(`搜索: ${value}`);
      // 实际项目中这里会跳转到搜索页面
    }
  };

  const userDropdown = (
    <Menu items={userMenuItems} />
  );

  const mobileMenu = (
    <Menu
      mode="inline"
      selectedKeys={selectedKeys}
      items={menuItems.map(item => ({
        key: item.key,
        icon: item.icon,
        label: item.label,
        onClick: () => {
          navigate(item.path);
          setDrawerVisible(false);
        }
      }))}
      className="mobile-menu"
    />
  );

  const handleLogin = () => {
    navigate('/auth');
  };

  return (
    <AntHeader className="app-header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/" onClick={() => setSelectedKeys(['home'])}>
            <span className="logo-text">我的博客</span>
          </Link>
        </div>

        {/* 桌面导航 */}
        <div className="desktop-nav">
          <Menu
            mode="horizontal"
            selectedKeys={selectedKeys}
            items={menuItems}
            onClick={handleMenuClick}
            className="nav-menu"
          />
          
          <Space size="middle">
            <Search
              placeholder="搜索文章..."
              onSearch={onSearch}
              className="header-search"
              size="middle"
              prefix={<SearchOutlined />}
            />
            
            {isLoggedIn ? (
              <Dropdown overlay={userDropdown} placement="bottomRight">
                <Avatar
                  size="large"
                  icon={<UserOutlined />}
                  className="user-avatar"
                  style={{ cursor: 'pointer' }}
                />
              </Dropdown>
            ) : (
              <Button
                type="primary"
                icon={<LoginOutlined />}
                onClick={handleLogin}
              >
                登录
              </Button>
            )}
          </Space>
        </div>

        {/* 移动端汉堡菜单 */}
        <div className="mobile-menu-btn">
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setDrawerVisible(true)}
            className="hamburger-btn"
          />
        </div>
      </div>

      {/* 移动端抽屉菜单 */}
      <Drawer
        title="导航菜单"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={280}
      >
        {mobileMenu}
        <div className="drawer-footer">
          {isLoggedIn ? (
            <Button block icon={<UserOutlined />} onClick={() => navigate('/about')}>
              个人中心
            </Button>
          ) : (
            <Button block type="primary" icon={<LoginOutlined />} onClick={() => {
              navigate('/auth');
              setDrawerVisible(false);
            }}>
              登录
            </Button>
          )}
        </div>
      </Drawer>
    </AntHeader>
  );
};

export default AppHeader;